import { FormlyFieldConfig } from '@ngx-formly/core';

export function emailValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `Please enter a valid email address`;
}
